import React, { useContext } from 'react';
import { DrawerHeader, Alert, Badge } from '@one-thd/sui-atomic-components';
import { ArrowForward, WarningFilled } from '@one-thd/sui-icons';
import { DrawerContext, InfoPerksContext } from '../../../../contexts';
import { useIsMobile } from '../../../../hooks';
import { assets } from '../../../../images/AssetPaths';
import { fallbackImage } from '../../../../images';
import { rhDrawer } from '../../../../constants/RewardsHub';
import { useDisplayAmount } from '../../../../utils/PerkOptionsUtil';
import { DrawerEventTriggers } from '../../../../utils/DrawerEventUtils';
export var UnclaimedPerkSlides = function () {
    var _a = useContext(InfoPerksContext), unclaimedPerksList = _a.unclaimedPerksList, perksInfo = _a.perksInfo;
    var _b = React.useContext(DrawerContext), onDrawerClose = _b.onDrawerClose, openSelectionPerks = _b.openSelectionPerks, onBackFromPAC = _b.onBackFromPAC, setDrawerOpen = _b.setDrawerOpen, isPacDrawersEnabled = _b.isPacDrawersEnabled;
    var isMobile = useIsMobile().isMobile;
    var slides = unclaimedPerksList === null || unclaimedPerksList === void 0 ? void 0 : unclaimedPerksList.map(function (perk, index) {
        var _a;
        var expireMessage = "".concat(perk.daysLeft, " day").concat(perk.daysLeft < 2 ? '' : 's', " left to use Perk");
        var eventOutput = {
            tierObj: perk,
            onClose: onDrawerClose,
            onBack: function () { return onBackFromPAC('PerksList'); },
            programId: (_a = perksInfo === null || perksInfo === void 0 ? void 0 : perksInfo.program) === null || _a === void 0 ? void 0 : _a.programId,
        };
        var onClick = function () {
            if (isPacDrawersEnabled) {
                setDrawerOpen(false);
                DrawerEventTriggers.triggerPerkSelectionDrawer(eventOutput);
            }
            else
                openSelectionPerks({ perk: perk, eventOutput: eventOutput });
        };
        return (React.createElement("button", { className: "sui-w-full sui-rounded-base sui-border-1 sui-border-solid sui-border-primary sm:sui-border-0 sui-my-4", key: "card-".concat(index), onClick: onClick, type: "button" },
            React.createElement("div", { className: "sui-w-full sui-flex sui-flex-row sui-justify-between sui-p-4 sm:sui-p-0" },
                React.createElement("div", { className: "sui-flex sui-flex-row sui-justify-center sui-align-start sui-pr-4  sui-text-left" },
                    React.createElement("img", { className: "sui-h-12 sui-w-12", src: assets.icons.badge_unlocked, alt: "Perks", height: "48", width: "48", onError: fallbackImage }),
                    React.createElement("div", { className: "sui-flex sui-flex-col sui-justify-center sui-align-start sui-pl-6" },
                        React.createElement("div", { className: "sui-flex sui-flex-row sui-justify-start sui-items-center sui-font-bold sui-text-lg" }, "New Perk Unlocked"),
                        React.createElement("div", { className: "sui-text-base sui-flex sui-flex-row sui-justify-start sui-pt-3" }, perk.daysLeft < 14 ? (React.createElement("div", { className: "sui-flex" },
                            React.createElement(WarningFilled, { color: "warning" }),
                            React.createElement("span", { className: "sui-pl-2" }, expireMessage))) : (React.createElement("div", null,
                            "Expires ",
                            perk.expirationTime))))),
                React.createElement("div", { className: "sui-flex sui-flex-col sui-justify-center" },
                    React.createElement("span", { className: "sui-text-brand" },
                        React.createElement(ArrowForward, { size: isMobile ? 'small' : 'regular' }))))));
    });
    return React.createElement("div", { className: "sui-flex sui-flex-col" }, slides);
};
export var ExpireMessage = function (_a) {
    var numOfDays = _a.numOfDays;
    var expireMessage = numOfDays > 0
        ? "Expires in ".concat(numOfDays, " day").concat(numOfDays < 2 ? '' : 's')
        : 'Expires Today';
    return React.createElement("span", null, expireMessage);
};
export var ActivePerkSlides = function (_a) {
    var perksList = _a.perksList;
    var _b = React.useContext(DrawerContext), onDrawerClose = _b.onDrawerClose, onBackFromPAC = _b.onBackFromPAC, openDetailsPerks = _b.openDetailsPerks, setDrawerOpen = _b.setDrawerOpen, isPacDrawersEnabled = _b.isPacDrawersEnabled;
    var getDisplayAmount = useDisplayAmount();
    var isMobile = useIsMobile().isMobile;
    var slides = perksList === null || perksList === void 0 ? void 0 : perksList.map(function (perk, index) {
        var expireMessage = "".concat(perk.daysLeft, " day").concat(perk.daysLeft < 2 ? '' : 's', " left to use Perk");
        // Calculate the difference in days between the current date and the activation time
        var today = new Date();
        var activationDate = new Date(perk.activationTime);
        var timeDiff = today.getTime() - activationDate.getTime();
        var daysSinceActivation = timeDiff / (1000 * 3600 * 24);
        var eventOutput = {
            perkObj: perk,
            onClose: onDrawerClose,
            onBack: function () { return onBackFromPAC('PerksList'); },
        };
        var onClick = function () {
            if (isPacDrawersEnabled) {
                setDrawerOpen(false);
                DrawerEventTriggers.triggerRewardBarcodeDrawer(eventOutput);
            }
            else
                openDetailsPerks({ perk: perk, eventOutput: eventOutput, showBack: true });
        };
        return (React.createElement("button", { 
            // eslint-disable-next-line tailwindcss/no-arbitrary-value
            className: "sui-w-full sui-rounded-base sui-border-1 sui-border-solid sui-border-primary sm:sui-border-0 sui-my-4", key: "card-".concat(index), onClick: onClick, type: "button" },
            React.createElement("div", { className: "sui-w-full sui-flex sui-flex-row sui-justify-between sui-p-4 sm:sui-p-0" },
                React.createElement("div", { className: "sui-flex sui-flex-row sui-justify-center sui-align-start sui-pr-4  sui-text-left" },
                    React.createElement("img", { className: "sui-h-12 sui-w-12", src: perk.perkImageUrl, alt: "Perks", height: "48", width: "48", onError: fallbackImage }),
                    React.createElement("div", { className: "sui-flex sui-flex-col sui-justify-center sui-align-start sui-pl-6" },
                        React.createElement("div", { className: "sui-flex sui-flex-row sui-justify-start sui-items-center sui-font-bold sui-text-lg sui-text-left" }, "".concat(getDisplayAmount(perk)).concat(perk.perkTitle)),
                        React.createElement("div", { className: "sui-text-base sui-flex sui-flex-row sui-justify-start sui-pt-3" }, perk.daysLeft < 14 &&
                            sessionStorage.getItem('perkClaimed') !== 'true' ? (React.createElement("div", { className: "sui-flex" },
                            React.createElement(WarningFilled, { color: "warning" }),
                            React.createElement("span", { className: "sui-pl-2" }, expireMessage))) : (React.createElement("div", null,
                            daysSinceActivation <= 14 && (React.createElement("span", { className: "sui-pr-2" },
                                React.createElement(Badge, { size: "small", variant: "strong", color: "brand" }, "New"))),
                            "Expires ",
                            perk.expirationTime))))),
                React.createElement("div", { className: "sui-flex sui-flex-col sui-justify-center" },
                    React.createElement("span", { className: "sui-text-brand" },
                        React.createElement(ArrowForward, { size: isMobile ? 'small' : 'regular' }))))));
    });
    return React.createElement("div", { className: "sui-flex sui-flex-col" }, slides);
};
export var PerkSlides = function () {
    var _a = useContext(InfoPerksContext), perksList = _a.perksList, unclaimedPerksList = _a.unclaimedPerksList, perksActivatedToday = _a.perksActivatedToday;
    var totalCount = (perksList === null || perksList === void 0 ? void 0 : perksList.length) +
        (unclaimedPerksList === null || unclaimedPerksList === void 0 ? void 0 : unclaimedPerksList.length) +
        (perksActivatedToday === null || perksActivatedToday === void 0 ? void 0 : perksActivatedToday.length);
    return (React.createElement(React.Fragment, null, totalCount === 0 ? (React.createElement(Alert, { status: "warning" }, rhDrawer.noPerks)) : (React.createElement(React.Fragment, null,
        perksActivatedToday && (React.createElement(ActivePerkSlides, { perksList: perksActivatedToday })),
        unclaimedPerksList && React.createElement(UnclaimedPerkSlides, null),
        perksList && React.createElement(ActivePerkSlides, { perksList: perksList })))));
};
export var ListDrawerHeader = function (_a) {
    var title = _a.title, handleClose = _a.handleClose;
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { className: "sui-pt-3" },
            React.createElement(DrawerHeader, { title: title, onClose: handleClose, className: "sui-flex sui-flex-col sui-pl-4 sui-pr-2" })),
        React.createElement("div", { className: "hide-shadow-div" })));
};
